import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Routes } from '€lib/routing';
import SettingsRouteOption from './SettingsRouteOption';
import SettingsLinkOption from './SettingsLinkOption';

interface SettingsOptionsProps {
    menuOptions: {
        heading: string;
        options: { label: string; location: Routes | null; href: string | null }[];
    }[];
}

const SettingsOptions: React.FunctionComponent<SettingsOptionsProps> = ({ menuOptions }) => {
    return (
        <Box mt={2}>
            {menuOptions && (
                <>
                    {menuOptions.map((menuOption, index) => (
                        <Box key={index}>
                            {menuOption.heading && (
                                <Box
                                    pl={{ xs: 0, sm: 3 }}
                                    py={1.5}
                                    borderLeft="3px solid transparent"
                                >
                                    <Typography variant="subtitle1">
                                        {menuOption.heading}
                                    </Typography>
                                </Box>
                            )}
                            {menuOption.options.map((option, k) =>
                                option.location ? (
                                    <Box key={k}>
                                        <SettingsRouteOption option={option} />
                                    </Box>
                                ) : (
                                    <Box key={k}>
                                        <SettingsLinkOption option={option} />
                                    </Box>
                                ),
                            )}
                        </Box>
                    ))}
                </>
            )}
        </Box>
    );
};

export default SettingsOptions;
